import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { useAppDispatch, useAppSelector } from "app/store";
import Loader from "components/loader";

import { authenticate } from "./thunk";
import { useOnAuthHandler } from "./hooks";
import { IAuthNProps } from "./definitions";

/**
 * Authentication component to render children after authenticating user
 */
const AuthN: React.FC<IAuthNProps> = ({ children }) => {
  const { t } = useTranslation();
  const authenticatingLabel = t("features.auth.authenticating");
  const dispatch = useAppDispatch();
  const { isAuthenticated, expiration } = useAppSelector((state) => state.auth);

  useOnAuthHandler();

  useEffect(() => {
    if (expiration > 0) {
      const currentTime = new Date().getTime() / 1000;
      const buffer = 30; // Refesh JWT 30 seconds before it expires
      const refreshDelay = Math.max(0, expiration - currentTime - buffer);
      setTimeout(() => dispatch(authenticate(true)), refreshDelay * 1000);
    } else {
      dispatch(authenticate(false));
    }
  }, [dispatch, expiration]);

  if (isAuthenticated) {
    return <React.Fragment>{children}</React.Fragment>;
  } else {
    return <Loader loadingText={authenticatingLabel} />;
  }
};

export default AuthN;
